import { type ApiClientResponse, apiClient, routes } from 'common/services';

export const completeOnboardingTour = async () =>
  apiClient.post<unknown, ApiClientResponse<unknown>>(routes.onboardingSteps.complateAll);
